import React from "react"
import PropTypes from "prop-types"
import styled, {css} from "styled-components"
import {BodyContainer} from "../../../shared"

const Inner = styled.div`
  ${({theme}) => css`
    max-width: 570px;
    margin-left: auto;
    margin-right: auto;
    padding: ${theme.spacing.one};
    ${theme.mediaQueries.minWidthMedia.desktop`
      padding: ${theme.spacing.one} ${theme.spacing.four} ${theme.spacing.four};
    `}
  `}
`

const Top = ({children, className}) => {
  return (
    <BodyContainer className={className}>
      <Inner>{children}</Inner>
    </BodyContainer>
  )
}

Top.propTypes = {
  children: PropTypes.node.isRequired,
  className: PropTypes.string
}

Top.defaultProps = {
  className: null
}

export default Top
